// extracted by mini-css-extract-plugin
module.exports = {"interface":"CheckDocxInterface_interface__2lYwz"};